import { QueryOptions } from 'react-query';
import { getAllOrgs, getOrgDetails } from './orgs.api';
import { AllOrgsResponse, OrgDetailResponse } from './orgs.schema';

export const ORGS_QUERY_KEY_PREFIX = 'orgs';

export const getAllOrgsQuery = (
  populate: boolean = false,
): QueryOptions<AllOrgsResponse> => ({
  queryKey: [ORGS_QUERY_KEY_PREFIX, { populate }],
  queryFn: () => getAllOrgs(populate),
});

export const getOrgDetailsQuery = (
  orgId: number,
): QueryOptions<OrgDetailResponse> => ({
  queryKey: [ORGS_QUERY_KEY_PREFIX, { orgId }],
  queryFn: () => getOrgDetails(orgId),
});
